import { render } from "./BeforeAfter.vue?vue&type=template&id=cdcfd72e&scoped=true"
import script from "./BeforeAfter.vue?vue&type=script&lang=js"
export * from "./BeforeAfter.vue?vue&type=script&lang=js"

import "./BeforeAfter.vue?vue&type=style&index=0&id=cdcfd72e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdcfd72e"]])

export default __exports__